/**
 * LEGACY — kept only so the Users module (`MapRolePage`) keeps compiling.
 *
 * This hits `/tenants/rbac/user-role`, which is NOT part of the real
 * tenant-admin Swagger contract — the endpoint does not exist yet. It was built
 * against a stale/imagined contract along with the rest of the Users module.
 *
 * 👉 Remove this file when the Users module is rebuilt against the real
 *    tenant-admin API (role assignment is expected to move under
 *    `PATCH /users/{email}`). It is intentionally NOT exported from the
 *    feature barrel (`index.ts`).
 */
import { httpClient } from '@/shared/services/http'
import { config } from '@/config'

export async function mapUserRoles(
  userId: string,
  roleIds: number[]
): Promise<unknown> {
  const response = await httpClient.post(
    '/tenants/rbac/user-role',
    { user_id: userId, role_ids: roleIds },
    { headers: { 'x-tenant-id': config.tenantId } }
  )
  return response.data
}
